import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule, NZ_I18N, en_US } from 'ng-zorro-antd';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
/** config angular i18n **/
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
registerLocaleData(en);
//ngrx
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './app.effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { EntityDataModule } from '@ngrx/data';
import { entityConfig } from './entity-metadata';
//module
import { ChartModule } from 'angular-highcharts';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared';
import { BusinessModule } from './business/business.module';
import { HomeModule } from './home/home.module';
import {NotBusinessModule} from './not-business/not-business.module';
import { SafePipe } from './safe.pipe';
import {AgentCtvModule} from './business/agent-ctv/agent-ctv.module';
@NgModule({
  declarations: [
    AppComponent,
    SafePipe,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot([]),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgZorroAntdModule,
    //ngrx
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: environment.production}),
    EffectsModule.forRoot([AppEffects]),
    StoreRouterConnectingModule.forRoot(),
    EntityDataModule.forRoot(entityConfig),
    //module
    ChartModule,
    AuthModule,
    SharedModule,
    BusinessModule,
    HomeModule,
    NotBusinessModule,
    AgentCtvModule
  ],
  bootstrap: [AppComponent],
  exports: [
  ],
  providers: [
    {
      provide: NZ_I18N,
      useValue: en_US
    }
  ]
})
export class AppModule { }
